import ResponsiveSidebar from "../../General/ResponsiveSidebar/ResponsiveSidebar";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  Route as RouteIcon,
} from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";

const drawerWidth = 240;
const collapsedWidth = 60;

interface SidebarProps {
  open?: boolean;
  toggle?: () => void;
}

const PermitsSidebar = ({ open = false, toggle = () => {} }: SidebarProps) => {
  const location = useLocation();

  const isSelected = () =>
    location.pathname === "/permits" ||
    location.pathname.startsWith("/permits/permit-route");

  const button = (
    <ListItemButton
      selected={isSelected()}
      component={RouterLink}
      to="/permits"
      sx={{ justifyContent: open ? "initial" : "center" }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: open ? 3 : 0,
          justifyContent: "center",
        }}
      >
        <RouteIcon />
      </ListItemIcon>
      <ListItemText primary="Permit route" sx={{ opacity: open ? 1 : 0 }} />
    </ListItemButton>
  );

  return (
    <ResponsiveSidebar
      open={open}
      onClose={toggle}
      sx={(theme) => ({
        width: open ? drawerWidth : collapsedWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? drawerWidth : collapsedWidth,
          boxSizing: "border-box",
          top: 64,
          height: "calc(100% - 64px)",
          overflowX: "hidden",
          position: "fixed",
          transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.standard,
          }),
        },
      })}
    >
      <Toolbar sx={{ justifyContent: open ? "flex-end" : "center" }}>
        <IconButton
          onClick={toggle}
          aria-label={
            open ? "Close section navigation" : "Open section navigation"
          }
        >
          {open ? <ChevronLeftIcon /> : <MenuIcon />}
        </IconButton>
      </Toolbar>
      <List>
        {open ? (
          button
        ) : (
          <Tooltip title="Permit route" placement="right">
            {button}
          </Tooltip>
        )}
      </List>
    </ResponsiveSidebar>
  );
};

export default PermitsSidebar;
